import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-import-create-icon',
  imports: [],
  templateUrl: './import-create-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './import-create-icon.component.scss',
})
export class ImportCreateIconComponent {}
